import {
  ADD_PAGE,
  GET_PAGEID,
  DELETE_PAGE,
  UPDATE_PAGECOLOR,
  UPDATE_PAGEIMAGE,
} from "../constants/ActionTypes";
import isEmpty from "lodash/isEmpty";

const INIT_STATE = {
  pages: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_PAGE: {
      console.log(action.payload);
      return {
        ...state,
        pages: [
          ...state.pages,
          {
            id: action.payload,
            color: "#ffffff",
            image: "",
          },
        ],
        success: !isEmpty(action.payload),
      };
    }
    case UPDATE_PAGECOLOR: {
      return {
        ...state,
        pages: state.pages.map((page) =>
          page.id === action.idPayload
            ? { ...page, color: action.colorPayload }
            : page
        ),
      };
    }

    case UPDATE_PAGEIMAGE: {
      return {
        ...state,
        pages: state.pages.map((page) =>
          page.id === action.idPayload
            ? { ...page, image: action.imagePayload }
            : page
        ),
      };
    }

    case DELETE_PAGE: {
      return {
        ...state,
        pages: state.pages.filter((page) => page.id !== action.payload),
        success: !isEmpty(action.payload),
      };
    }

    case GET_PAGEID: {
      return {
        ...state,
        lastId: action.payload,
        success: !isEmpty(action.payload),
      };
    }

    default:
      return state;
  }
};
